/* Header-Farbe folgt der Welt unter dem Header.
   Die Sektionsliste wird bei jedem Lauf neu gelesen — im Theme-Editor
   kommen und gehen Sections zur Laufzeit. */
(() => {
  const header = document.getElementById('header');
  if (!header) return;

  const setWelt = () => {
    const y = header.offsetHeight * 0.5;
    let licht = false;
    document.querySelectorAll('.licht, .dunkel').forEach(s => {
      // data-welt-aus: dunkles Objekt auf heller Seite (Produktkarte unter
      // den Ratgebern), keine eigene Welt. Der Header bleibt dort hell.
      if (s === header || s.hasAttribute('data-welt-aus')) return;
      const r = s.getBoundingClientRect();
      if (r.top <= y && r.bottom > y) licht = s.classList.contains('licht');
    });
    header.classList.toggle('ueber-licht', licht);

    /* Ueber dem Hero bleibt der Header transparent und schwebt: die
       Scroll-Sequenz ist der Auftritt, eine Milchglaskante daraufgelegt
       nimmt ihr die Wirkung. Erst wenn die Sequenz durchgelaufen ist,
       blendet die Flaeche ein — ab da schiebt sich Sektionstext unter den
       Header und wuerde sonst mit dem Logo kollidieren.

       Die Schwelle ist die Unterkante der Hero-Zone abzueglich einer
       Viewporthoehe: genau der Scrollstand, an dem ScrollTrigger seinen
       Fortschritt auf 1 setzt (start 'top top', end 'bottom bottom').
       Ohne Hero-Zone — jede andere Seite — bleibt es beim alten Verhalten.

       Bei prefers-reduced-motion faellt die Zone auf height:auto zusammen
       und die Schwelle wird von selbst klein; ein Sonderfall ist dafuer
       nicht noetig. */
    const zone = document.querySelector('[data-hero-zone]');
    let schwelle = 8;
    if (zone) {
      const zr = zone.getBoundingClientRect();
      schwelle = Math.max(8, zr.bottom + scrollY - innerHeight);
    }
    header.classList.toggle('ist-gescrollt', scrollY >= schwelle);
  };

  addEventListener('scroll', setWelt, { passive: true });
  addEventListener('resize', setWelt);
  document.addEventListener('shopify:section:load', setWelt);
  document.addEventListener('shopify:section:unload', setWelt);
  setWelt();
})();
